import React from 'react';
import { NavigationBar } from './components/NavigationBar';
import Dashboard from './components/Dashboard';
export function App() {
  return <div className="flex flex-col min-h-screen bg-gray-100" data-id="element-0">
      <NavigationBar data-id="element-1" />
      <div className="w-[95%] mx-auto px-4 py-4" data-id="element-2">
        <Dashboard data-id="element-3" />
      </div>
    </div>;
}